import OrderDeliveryDetails from './OrderDeliveryDetails'

export default OrderDeliveryDetails
